export default [
  {
    title: "유지·보수 작업",
    check: false,
    subTitle: "사전조사 및 작업계획서 내용(산업안전보건기준에 관한 규칙 [별표4], 제38조 제1항관련)",
    typeLists: [
      {
        headerTitle: "작업계획서 내용",
        data: [
          {
            content: ["가", "개인보호구는 반드시 착용할 것(예시: 방독, 휴대용산소, 보안경 등)"],
            isChecked: "",
          },
          {
            content: ["나", "작업 종료 후 작업구간 안전점검 철저"],
            isChecked: "",
          },
          {
            content: ["다", "작업순서를 준수하여 관리감독 하에 작업"],
            isChecked: "",
          },
        ],
      },
    ],
  },
  {
    title: "주말·휴일작업",
    check: false,
    subTitle: "위험작업내용",
    typeLists: [
      {
        headerTitle: "위험작업",
        data: [
          {
            content: ["가", "타워크레인을 설치·조립·해체·상승작업"],
            isChecked: "",
          },
          {
            content: ["나", "콘크리트 타설·양생작업"],
            isChecked: "",
          },
          {
            content: ["다", "이동식 크레인 및 고소작업대 사용작업"],
            isChecked: "",
          },
          {
            content: ["라", "외부비계 설치·해체작업"],
            isChecked: "",
          },
          {
            content: ["마", "거푸집 설치·해체작업"],
            isChecked: "",
          },
        ],
      },
      {
        headerTitle: "사고 시 비상대응체계",
        data: [
          {
            content: ["가", ""],
            sign: [{ name: "원청", value: "", nameWidth: "80px", valueWidth: "100%" }],
            isChecked: "",
          },
          {
            content: ["나", ""],
            sign: [{ name: "작업업체", value: "", nameWidth: "80px", valueWidth: "100%" }],
            isChecked: "",
          },
          {
            content: ["다", ""],
            sign: [{ name: "감리단", value: "", nameWidth: "80px", valueWidth: "100%" }],
            isChecked: "",
          },
          {
            content: ["라", ""],
            sign: [{ name: "병원", value: "", nameWidth: "80px", valueWidth: "100%" }],
            isChecked: "",
          },
          {
            content: ["마", ""],
            sign: [{ name: "고용부", value: "", nameWidth: "80px", valueWidth: "100%" }],
            isChecked: "",
          },
          {
            content: ["바", ""],
            sign: [{ name: "경찰", value: "", nameWidth: "80px", valueWidth: "100%" }],
            isChecked: "",
          },
        ],
      },
    ],
  },
  {
    title: "기타작업(야간작업)",
    check: false,
    subTitle: "사전조사 및 작업계획서 내용(산업안전보건기준에 관한 규칙 [별표4], 제38조 제1항관련)",
    typeLists: [
      {
        headerTitle: "작업환경 요인",
        data: [
          {
            content: ["가", "조도 관리는 노동자의 연령과 작업특성을 고려하여 작업장 조명의 밝기(2,500 ~ 9,500lux)는 유지되는가?"],
            isChecked: "",
          },
          {
            content: ["나", "온도 조절은 야간작업 시 작업장의 온도를 적절한 수준(27℃가 넘지 않는 범위에서 주간작업 때보다 약 1℃정도 높임)으로 유지되는가?"],
            isChecked: "",
          },
          {
            content: ["다", "편의시설 제공 및 응급처치 설비, 이송 등의 치료체계 확보 여부?"],
            isChecked: "",
          },
        ],
      },
      {
        headerTitle: "작업조건 요인",
        data: [
          {
            content: ["가", "야간반 교대시간은 가급적 자정 이전으로 해야하고 연속 3일 이상의 야간작업은 자제하는가?"],
            isChecked: "",
          },
          {
            content: ["나", "교대작업 방법은 아침반 > 저녁반 > 야간반 > 아침반 등의 순으로 교대방향을 유지하고 있는가?"],
            isChecked: "",
          },
          {
            content: ["다", "야간반 근무를 마친 후 아침반 근무에 들어가기 전 최소한 24시간 이상 휴식을 취하고 있는가?"],
            isChecked: "",
          },
          {
            content: ["라", "갑자기 주어지는 야근이나 철야작업으로 인해 노동자가 항상 대기 상황에 처하지 않도록 예측 가능한 교대작업의 정보를 제공하고 있는가?"],
            isChecked: "",
          },
          {
            content: ["마", "야간작업으로 인한 사고 발생 확률 저감을 위하여 교대작업일수, 업무 내용 등을 탄력적으로 조정하고 있는가?"],
            isChecked: "",
          },
        ],
      },
      {
        headerTitle: "건강문제 요인",
        data: [
          {
            content: ["가", "생체주기의 변화 및 일주기 리듬의 교란으로 인한 건강상의 문제에 대처하고 있는가?"],
            isChecked: "",
          },
          {
            content: ["나", "누적된 피로로 인한 사고 발생 위험성 저감을 위해 대처하고 있는가?"],
            isChecked: "",
          },
          {
            content: ["다", "정기적인 건강상태 확인이 유지되고 있는가?"],
            isChecked: "",
          },
          {
            content: ["라", "야간작업에 대한 교육 및 훈련이 실행되고 있는가?"],
            isChecked: "",
          },
          {
            content: ["마", "노동자 생활 습관 관리를 위한 재충전의 기회를 제공하고 있는가?"],
            isChecked: "",
          },
        ],
      },
    ],
  },
];
